module.exports = __webpack_public_path__ + "static/media/bookstore_videos.4f236ab6.png";